import React, { useState } from 'react'
import { Edit3, Copy, ImageIcon, Archive, ArchiveRestore } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { getImageUrl } from '@/services/blogService'
import { BlogStatusBadge } from './BlogStatusBadge'

export function BlogPostRow({ post, onEdit, onDuplicate, onArchive, onRestore }) {
  const [imageError, setImageError] = useState(false)

  return (
    <div
      className="flex cursor-pointer items-center gap-4 border-b border-border px-4 py-3 last:border-b-0 hover:bg-accent/50"
      onClick={() => onEdit(post)}
    >
      <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-md bg-muted">
        {post.image && !imageError ? (
          <img
            src={getImageUrl(post.image)}
            alt={post.image_alt || post.title}
            className="h-full w-full object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          <ImageIcon className="h-5 w-5 text-muted-foreground" />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium">{post.title}</p>
        <p className="text-xs text-muted-foreground">
          {post.published_date} · {post.read_time || 0} min read
        </p>
      </div>
      <div className="w-32 shrink-0 truncate text-center text-sm text-muted-foreground">{post.category || 'Uncategorized'}</div>
      <div className="flex w-24 shrink-0 justify-center">
        <BlogStatusBadge published={post.published} archived={post.is_archived} />
      </div>
      <div className="flex w-[160px] shrink-0 items-center justify-center gap-1.5" onClick={(event) => event.stopPropagation()}>
        {post.is_archived ? (
          <Button type="button" variant="outline" size="sm" className="h-7 px-2 text-xs" onClick={() => onRestore(post)}>
            <ArchiveRestore className="mr-1 h-3 w-3" /> Restore
          </Button>
        ) : (
          <>
            <Button type="button" variant="outline" size="sm" className="h-7 px-2 text-xs" onClick={() => onEdit(post)}>
              <Edit3 className="mr-1 h-3 w-3" /> Edit
            </Button>
            <Button type="button" variant="outline" size="sm" className="h-7 w-7 p-0" title="Duplicate" onClick={() => onDuplicate(post)}>
              <Copy className="h-3 w-3" />
            </Button>
            <Button type="button" variant="outline" size="sm" className="h-7 w-7 p-0" title="Archive" onClick={() => onArchive(post)}>
              <Archive className="h-3 w-3" />
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
